import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be 8+ chars"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { currentPassword: cur, newPassword: next });
      toast.success("Password updated");
      await refresh();
      nav(user?.role === "admin" ? "/admin" : user?.role === "streamer" ? "/streamer" : "/player");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Change failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 lg:py-24">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Security</div>
      <div className="flex items-center gap-3 mb-6"><KeyRound className="w-6 h-6 text-[#F5B841]" /><h1 className="font-display text-4xl font-black tracking-tighter">Change password</h1></div>
      {user?.mustChangePassword && (
        <div className="border border-[#F5B841]/40 bg-[#F5B841]/5 p-3 text-xs text-[#F5B841] mb-6" data-testid="force-change-banner">Your temporary password must be replaced before you can continue.</div>
      )}
      <form onSubmit={submit} className="space-y-5" data-testid="change-password-form">
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">Current password</Label>
          <Input data-testid="cp-current" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-[#2DD4A7]" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">New password</Label>
          <Input data-testid="cp-new" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-[#2DD4A7]" />
        </div>
        <Button data-testid="cp-submit" type="submit" disabled={busy} className="w-full rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-12 font-semibold transition-colors">
          {busy ? "…" : "Update password"}
        </Button>
      </form>
    </div>
  );
}
